import React, { Component } from "react";
import Logout from "../assets/logout.svg";
import Back from "../assets/back.svg";
import RoutinItem from "../components/RoutinItem";
import licenseplan from "../assets/licenseplan.svg";
import { Modal, Form } from "react-bootstrap";
import { WhisperSpinner } from "react-spinners-kit";
import { toast } from "react-toastify";
import CustomButton from "../components/CustomButton";
import Tick from "../assets/tick.svg";
import { NumericFormat } from "react-number-format";
import Loading from "../components/Loading";
import Cancel from "../assets/cancel.svg";
import Plus from "../assets/plus.svg";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import momentjalali from "moment-jalaali";
import moment from "moment-timezone";
import {
  BaseUrl,
  Authorization,
  BaseUrlPublic,
  isUser,
  LogoutFunction,
} from "../static.js";
import { Icon } from "@iconify/react";
import refresh02 from "@iconify/icons-ci/refresh-02";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import ListViewer from "../components/ListViewer";
import SortableList, { SortableItem } from "react-easy-sort";
import Tooltip from "@mui/material/Tooltip";

export default class OrderRoutines extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataLoading: true,
      confirmLoading: false,
      stepList: [],
      ModalShow: false,
      currentItem: null,
      pageStatus: "normal",
      paymentToken: "",
      gridLocaleText: {
        selectAll: "انتخاب همه",
        selectAllSearchResults: "انتخاب همه نتایج جستجو",
        searchOoo: "جستجو...",
        blanks: "خالی",
        noMatches: "پشدا نشد",
        filterOoo: "فیلتر...",
        equals: "مساوی",
        notEqual: "نا مساوی",
        lessThan: "کمتر از",
        greaterThan: "بیشتر از",
        lessThanOrEqual: "کوچکتر مساوی",
        greaterThanOrEqual: "بزرگتر مساوی",
        inRange: "در محدوده",
        inRangeStart: "به",
        inRangeEnd: "از",
        contains: "شامل",
        notContains: "شامل نباشد",
        startsWith: "شروع با",
        endsWith: "پایان با",
        andCondition: "و",
        orCondition: "یا",
        applyFilter: "تایید",
        resetFilter: "راه اندازی مجدد",
        clearFilter: "پاک کردن",
        cancelFilter: "انصراف",
        columns: "ستون ها",
        filters: "فیلترها",
        group: "گروه",
        loadingOoo: "لطفاً شکیبا باشید...",
        noRowsToShow: "هیچ موردی یافت نشد",
        enabled: "فعال",
        sum: "جمع",
        min: "کمترین",
        max: "بیشترین",
        none: "None",
        count: "تعداد",
        avg: "میانگین",
        filteredRows: "فیلتر شده",
        selectedRows: "انتخاب شده",
        totalRows: "جمع ردیف ها",
        totalAndFilteredRows: "ردیف ها",
        page: "صفحه",
        more: "بیشتر",
        to: "تا",
        of: "از",
        next: "بعدی",
        last: "آخرین",
        first: "اولین",
        previous: "قبلی",
      },
      rowData: [],
      columnDefs: [
        {
          headerName: "عنوان",
          field: "packageId",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "مبلغ",
          field: "price",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "وضعیت",
          field: "status",
          cellRenderer: "formatStatus",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تاریخ درخواست",
          field: "createdAt",
          cellRenderer: "formatDateTime",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],
      frameworkComponents: {
        formatCurrency: this.formatCurrency,
        formatDateTime: this.formatDateTime,
        formatStatus: this.formatStatus,
      },
      resID: null,
      tableLoading: true,
      subtitleText: "",
      titleErrorText: "",
      titleValue: "",
      desErrorText: "",
      desValue: "",
      otherCats: false,
      otherStation: false,
      otherUsers: false,
      selectedPlaceList: [],
      placeList: [],
      placeListLoading: false,
      selectedCatList: [],
      catList: [],
      selectedStationList: [],
      stationList: [],
      selectedUserList: [],
      userList: [],
      listType: "",
      currentRoutinItem: null,
      deleteModalShow: false,
      editDesModalShow: false,
      currentDeleteItemName: "",
      warningList: [],
      warningModalShow: false,
      printerListLoading: false,
      selectedPrinterList: [],
      printerList: [],
    };

    this.createEditProcess = this.createEditProcess.bind(this);

    this.paymentForm = React.createRef();
    this.tableContainer = React.createRef();
  }

  formatStatus(params) {
    switch (params.value) {
      case "pending":
        return "در حال بررسی...";
      case "complete":
        return "تایید شده";
      case "failed":
        return "رد شده";
      default:
        break;
    }
    return params.value;
  }

  formatCurrency(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      return (
        <NumericFormat
          value={params.value}
          displayType={"text"}
          thousandSeparator={true}
          suffix={" ریال"}
        />
      );
    } catch (error) {
      return "-";
    }
  }

  formatDateTime(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      var zone_name = moment.tz.guess();
      let newdatetime = moment
        .tz(params.value, zone_name)
        .format("yyyy-MM-DD HH:mm")
        .toString()
        .split(" ");

      let result =
        newdatetime[1] +
        " " +
        momentjalali(newdatetime[0]).format("jYYYY/jMM/jDD");

      return result;
    } catch (error) {
      return "-";
    }
  }

  componentDidMount() {
    this.findBusinessWithCode();
  }

  findBusinessWithCode() {
    let data = {
      businessCode: this.props.match.params.id,
    };

    this.setState({ dataLoading: true });

    fetch(BaseUrlPublic + "findBusinessWithCode", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          this.setState({ resID: result.result[0].id }, () => {
            this.getPrinters(true);
          });
        } else if (result.status === 401) {
          LogoutFunction();
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false });
      });
  }

  readOrderProcess() {
    let data = {
      businessCode: this.props.match.params.id,
      // businessUserType: [4],
    };
    data = Object.assign(data, Authorization());
    console.log(data);
    fetch(BaseUrl + "readOrderProcess", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("readOrderProcess: ", result);
        if (result.status === 200) {
          let newList = [];
          result.result.forEach((element) => {
            let found = false;
            newList.every((element1) => {
              if (!found && element1.BUTId === element.BUTId) {
                found = true;
                element1.childs.push(element);
                return false;
              }
              return true;
            });

            if (!found) {
              let pn = "";

              this.state.placeList.forEach((element1) => {
                if (element1.id === element.BUTId) {
                  pn = element1.titleFa;
                }
              });
              newList.push({
                BUTId: element.BUTId,
                placeName: pn,
                statusText: element.statusText,
                childs: [element],
              });
            }
          });
          this.setState({
            dataLoading: false,
            stepList: newList,
          });
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getPrinters(isFirst) {
    let data = {
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "getPrinters", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("getPrinters: ", result);
        if (result.status === 200) {
          this.setState(
            {
              printerList: result.result,
              printerListLoading: false,
            },
            () => {
              if (isFirst) this.getPlace(isFirst);
            }
          );
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getPlace(isFirst) {
    let data = {
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "readBusinessUserTypeList", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("readBusinessUserTypeList: ", result);
        if (result.status === 200) {
          this.setState(
            {
              placeList: result.ruleList,
              placeListLoading: false,
            },
            () => {
              if (isFirst) this.getUsers(isFirst);
            }
          );
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getUsers(isFirst) {
    let data = {
      businessCode: this.props.match.params.id,
      page: 1,
      count: 100,
      businessUserType: this.state.selectedPlaceList[0],
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "readBusinessUserList", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("readBusinessUserList: ", result);
        if (result.status === 200) {
          console.log("result.result: ", result.result);
          this.setState(
            {
              placeListLoading: false,
              userList: result.result,
            },
            () => {
              if (isFirst) this.getStations(isFirst);
              else {
                let list = JSON.parse(
                  JSON.stringify(this.state.selectedUserList)
                );
                console.log("list: ", list);
                console.log("selectedUserList: ", this.state.selectedUserList);

                let final = this.opimizeUsers(list, result.result);
                console.log("selectedUserList: ", final);
                this.setState({
                  selectedUserList: final,
                });
              }
            }
          );
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  opimizeUsers(list, mainList) {
    let index = 0;
    let indexs = [];
    list.forEach((element) => {
      let found = false;
      mainList.forEach((element1) => {
        if (element1.id === element) {
          found = true;
        }
      });
      if (!found) indexs.push(index);
      index++;
    });
    indexs.forEach((element) => {
      list.splice(element, 1);
    });
    return list;
  }

  getStations(isFirst) {
    let data = {
      businessId: this.state.resID,
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "findAllStation", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("getTables", result);
        if (result.status === 200) {
          this.setState(
            {
              stationList:
                result.result.length > 0 ? result.result.reverse() : [],
            },
            () => {
              if (isFirst) this.getMenu(isFirst);
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        }
        this.setState({ placeListLoading: false });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ placeListLoading: false });
      });
  }

  getMenu(isFirst) {
    let data = {
      type: "getMenuWithBusinessCode",
      languageId: this.state.defaultLanguage,
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());
    console.log(data);
    fetch(BaseUrl + "getMenu", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          let menu = JSON.parse(JSON.stringify(result.result));
          menu.forEach((element) => {
            let catname = "";
            element.nameObj.forEach((element1) => {
              if (element1.languageId === 1) {
                catname = element1.name;
              }
            });

            if (catname === "") {
              element.nameObj.forEach((element1) => {
                if (element1.languageId === this.state.defaultLanguage) {
                  catname = element1.name;
                }
              });
            }

            if (catname === "") {
              element.nameObj.forEach((element1) => {
                if (catname === "" && element1.name !== "") {
                  catname = element1.name;
                }
              });
            }

            element.name = catname;

            element.items.forEach((element2) => {
              let itemname = "";
              let itemdescr = "";

              element2.nameObj.forEach((element3) => {
                if (element3.languageId === 1) {
                  itemname = element3.name;
                }
              });

              if (itemname === "") {
                element2.nameObj.forEach((element3) => {
                  if (element3.languageId === this.state.defaultLanguage) {
                    itemname = element3.name;
                  }
                });
              }

              if (itemname === "") {
                element2.nameObj.forEach((element3) => {
                  if (itemname === "" && element3.name !== "") {
                    itemname = element3.name;
                  }
                });
              }

              element2.descrObj.forEach((element3) => {
                if (element3.languageId === 1) {
                  itemdescr = element3.descr;
                }
              });

              if (itemdescr === "") {
                element2.descrObj.forEach((element3) => {
                  if (element3.languageId === this.state.defaultLanguage) {
                    itemdescr = element3.descr;
                  }
                });
              }

              if (itemdescr === "") {
                element2.descrObj.forEach((element3) => {
                  if (itemdescr === "" && element3.descr !== "") {
                    itemdescr = element3.descr;
                  }
                });
              }

              element2.descr = itemdescr;
              element2.name = itemname;
            });
          });

          this.setState({ catList: menu }, () => {
            if (isFirst) this.readOrderProcess();
          });
        } else if (result.status === 401) {
          LogoutFunction();
        }

        this.setState({ placeListLoading: false });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ placeListLoading: false });
      });
  }

  onBack() {
    this.props.history.push("/Restaurants/" + this.props.match.params.id);
  }

  onLogout() {
    LogoutFunction();
  }

  onClickToBuy(id) {
    this.state.stepList.forEach((element) => {
      if (element.id === id) {
        this.setState({ currentItem: element }, () => {
          this.setState({ ModalShow: true });
        });
      }
    });
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  onConfirmToBuy() {
    this.setState({ dataLoading: true });

    let data = {
      packageId: this.state.currentItem.id,
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    console.log(data);

    fetch(BaseUrl + "sendForPayment", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          console.log(result);
          this.setState({
            dataLoading: false,
            ModalShow: false,
          });
          toast.success("درخواست شما با موفقیت ارسال شد", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        } else if (result.status === 401) {
          LogoutFunction();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  hideModal1() {
    this.setState({ rowData: [], ModalShow1: false });
  }

  onFirstDataRendered(params) {
    try {
      params.api.sizeColumnsToFit();
      window.setTimeout(() => {
        const colIds = params.columnApi.getAllColumns().map((c) => c.colId);
        params.columnApi.autoSizeColumns(colIds, false);

        let cols = params.columnApi.getColumnState();
        let width = 0;
        cols.forEach((element) => {
          width += element.width;
        });

        if (
          width <
          this.tableContainer.current.getBoundingClientRect().width - 10
        ) {
          let def =
            this.tableContainer.current.getBoundingClientRect().width -
            10 -
            width;
          if (def > cols.length) {
            let newwidth = def / cols.length;
            cols.forEach((element) => {
              params.columnApi.setColumnWidth(
                element.colId,
                element.width + newwidth
              );
            });
          } else {
            params.columnApi.setColumnWidth(cols[0].colId, cols[0].width + def);
          }
        }
      }, 50);
    } catch (error) {}
  }

  ShowCreateNewDialog() {
    this.setState({
      ModalShow: true,
      selectedCatList: [],
      selectedStationList: [],
      selectedUserList: [],
      selectedPlaceList: [],
      selectedPrinterList: [],
      titleValue: "",
      desValue: "",
      otherCats: false,
      otherStation: false,
      otherUsers: false,
      currentRoutinItem: null,
    });
  }

  textHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onShowPlaces() {
    this.setState(
      {
        ModalShow1: true,
        placeListLoading: false,
        listType: "place",
        placeList: [],
      },
      () => {
        this.getPlace(false);
      }
    );
  }

  onShowPrinter() {
    this.setState(
      {
        ModalShow1: true,
        printerListLoading: false,
        listType: "printer",
        printerList: [],
      },
      () => {
        this.getPrinters(false);
      }
    );
  }

  onShowCats() {
    this.setState(
      {
        ModalShow1: true,
        placeListLoading: true,
        listType: "product",
        catList: [],
      },
      () => {
        this.getMenu(false);
      }
    );
  }

  onShowStations() {
    this.setState(
      {
        ModalShow1: true,
        placeListLoading: true,
        listType: "station",
        stationList: [],
      },
      () => {
        this.getStations(false);
      }
    );
  }

  onShowUsers() {
    this.setState(
      {
        ModalShow1: true,
        placeListLoading: true,
        listType: "user",
        userList: [],
      },
      () => {
        this.getUsers(false);
      }
    );
  }

  onConfirmStep() {
    if (!this.state.titleValue) {
      this.setState({ titleErrorText: "عنوان این گام را مشخص کنید" });
      return;
    } else {
      this.setState({ titleErrorText: "" });
    }

    if (this.state.selectedPlaceList.length < 1) {
      toast.error("لطفاً محل مورد نظر را انتخاب کنید", {
        position: toast.POSITION.BOTTOM_RIGHT,
        hideProgressBar: true,
        autoClose: 6000,
        toastClassName: "toast",
      });
      return;
    }

    if (this.state.selectedCatList.length < 1) {
      toast.error("محصول مورد نظر خود را انتخاب کنید", {
        position: toast.POSITION.BOTTOM_RIGHT,
        hideProgressBar: true,
        autoClose: 6000,
        toastClassName: "toast",
      });
      return;
    }

    if (this.state.selectedStationList.length < 1) {
      toast.error("ایستگاه‌های مورد نظر خود را انتخاب کنید", {
        position: toast.POSITION.BOTTOM_RIGHT,
        hideProgressBar: true,
        autoClose: 6000,
        toastClassName: "toast",
      });
      return;
    }

    if (this.state.selectedUserList.length < 1) {
      toast.error("کاربران مورد نظر خود را انتخاب کنید", {
        position: toast.POSITION.BOTTOM_RIGHT,
        hideProgressBar: true,
        autoClose: 6000,
        toastClassName: "toast",
      });
      return;
    }

    let cl = [];
    let sl = [];
    let ul = [];
    // console.log("fldkfslk", this.state.selectedCatList);
    this.state.selectedCatList.forEach((element) => {
      cl.push(element.id);
    });
    // console.log("2");
    // cl = this.state.selectedCatList;

    sl = this.state.selectedStationList;

    ul = this.state.selectedUserList;

    let data = {
      businessCode: this.props.match.params.id,
      BUTId: this.state.selectedPlaceList[0],
      foodList: cl,
      orderStationList: sl,
      businessUserList: ul,
    };

    data = Object.assign(data, Authorization());
    console.log(data);
    fetch(BaseUrl + "checkForWarning", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("checkForWarning: ", result);
        if (result.status === 200) {
          let warning = [];

          result.foodList.forEach((element) => {
            let catname = "";
            element.nameObj.forEach((element1) => {
              if (element1.languageId === 1) {
                catname = element1.title;
              }
            });

            if (catname === "") {
              element.nameObj.forEach((element1) => {
                if (element1.languageId === this.state.defaultLanguage) {
                  catname = element1.title;
                }
              });
            }

            if (catname === "") {
              catname = element.nameObj[0].title;
            }

            warning.push(
              "محصول '" +
                catname +
                "' در گام '" +
                element.OPTitle +
                "' استفاده شده است."
            );
          });

          result.OSList.forEach((element) => {
            warning.push(
              "ایستگاه '" +
                element.OSName +
                "' در گام '" +
                element.OPTitle +
                "' استفاده شده است."
            );
          });

          result.BUList.forEach((element) => {
            warning.push(
              "کاربر '" +
                element.userName +
                "' در گام '" +
                element.OPTitle +
                "' استفاده شده است."
            );
          });

          if (warning.length > 0) {
            this.setState({ warningList: warning }, () => {
              this.setState({ warningModalShow: true });
            });
          } else {
            this.createEditProcess();
          }
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  createEditProcess() {
    let cl = [];
    let sl = [];
    let ul = [];
    // cl = this.state.selectedCatList;
    // console.log("selectedCatList:", this.state.selectedCatList);
    this.state.selectedCatList.forEach((element) => {
      cl.push(element.id);
    });
    // console.log(1);
    sl = this.state.selectedStationList;

    ul = this.state.selectedUserList;

    let data = [];
    let apiName = "";

    let statusText = "";
    this.state.placeList.forEach((element) => {
      if (element.id === this.state.selectedPlaceList[0]) {
        statusText = element.statusText;
      }
    });

    if (!this.state.currentRoutinItem) {
      let priority = this.state.stepList.length + 1;

      let i = 1;
      this.state.stepList.forEach((element) => {
        if (element.BUTId === this.state.selectedPlaceList[0]) {
          priority = i;
        }
        i++;
      });

      data = {
        businessCode: this.props.match.params.id,
        priority: priority,
        BUTId: this.state.selectedPlaceList[0],
        title: this.state.titleValue,
        statusText: statusText,
        foodList: cl,
        orderStationList: sl,
        businessUserList: ul,
        printerId:
          this.state.selectedPrinterList.length > 0
            ? this.state.selectedPrinterList[0]
            : null,
      };
      apiName = "createOrderProcess";
    } else {
      data = {
        businessCode: this.props.match.params.id,
        priority: this.state.currentRoutinItem.priority,
        processId: this.state.currentRoutinItem.id,
        BUTId: this.state.selectedPlaceList[0],
        title: this.state.titleValue,
        statusText: statusText,
        foodList: cl,
        orderStationList: sl,
        businessUserList: ul,
        printerId:
          this.state.selectedPrinterList.length > 0
            ? this.state.selectedPrinterList[0]
            : null,
      };
      apiName = "editStepOnProcess";
    }

    data = Object.assign(data, Authorization());
    console.log(data);
    fetch(BaseUrl + apiName, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          this.setState({ ModalShow: false });
          this.readOrderProcess();
          if (apiName === "createOrderProcess") {
            toast.success("گام جدید با موفقیت ایجاد شد", {
              position: toast.POSITION.BOTTOM_RIGHT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            });
          } else {
            toast.success("گام مورد نظر با موفقیت ویرایش شد", {
              position: toast.POSITION.BOTTOM_RIGHT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            });
          }
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onConfirmPlace(list) {
    this.setState({ selectedPlaceList: list, ModalShow1: false }, () => {
      this.getUsers(false);
    });
  }

  onConfirmPrinter(list) {
    this.setState({ selectedPrinterList: list, ModalShow1: false }, () => {
      this.getPrinters(false);
    });
  }

  onConfirmProduct(list) {
    this.setState({ selectedCatList: list, ModalShow1: false });
  }

  onConfirmStation(list) {
    this.setState({ selectedStationList: list, ModalShow1: false });
  }

  onConfirmUser(list) {
    console.log(list);
    this.setState({ selectedUserList: list, ModalShow1: false });
  }

  onDragEnd(oldIndex, newIndex) {
    if (oldIndex !== newIndex) {
      var list = JSON.parse(JSON.stringify(this.state.stepList));
      var tempList = JSON.parse(JSON.stringify(this.state.stepList));

      list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);

      let i = 1;
      let newData = [];
      list.forEach((element) => {
        element.childs.forEach((element1) => {
          element1.priority = i;

          newData.push({ id: element1.id, priority: i });
        });
        i++;
      });

      this.setState({ stepList: list });

      let data = {
        businessCode: this.props.match.params.id,
        orderProcess: newData,
      };
      data = Object.assign(data, Authorization());

      console.log("data", data);
      // return
      fetch(BaseUrl + "changeOrderProcessPriority", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          console.log(result);
          if (result.status !== 200) {
            if (result.status === 401) {
              LogoutFunction();
            } else {
              this.setState({ stepList: tempList });
              toast.error(result.message, {
                position: toast.POSITION.BOTTOM_RIGHT,
                hideProgressBar: true,
                autoClose: 6000,
                toastClassName: "toast",
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  editRoutinItem(item) {
    let foodList = item.foodList ? item.foodList : [];
    let list = [];
    this.state.catList.forEach((element) => {
      element.items.forEach((element1) => {
        if (foodList.indexOf(element1.id) > -1) {
          element1.selected = true;
          list.push(element1);
        }
      });
    });
    console.log(item);
    this.setState({
      ModalShow: true,
      selectedCatList: list,
      selectedStationList: item.orderStationList ? item.orderStationList : [],
      selectedUserList: item.businessUserList ? item.businessUserList : [],
      selectedPlaceList: [item.BUTId],
      selectedPrinterList: [item.printerId],
      titleValue: item.title,
      desValue: item.statusText,
      otherCats: item.otherCategory === 0 ? false : true,
      otherStation: item.otherOrderStation === 0 ? false : true,
      otherUsers: item.otherBusinessUser === 0 ? false : true,
      currentRoutinItem: item,
    });
  }

  deleteRoutinItem(item) {
    this.setState({
      currentDeleteItemId: item.id,
      currentDeleteItemName: item.title,
      deleteModalShow: true,
    });
  }

  itemDeleteConfirm() {
    let data = {
      businessCode: this.props.match.params.id,
      processId: this.state.currentDeleteItemId,
    };
    data = Object.assign(data, Authorization());

    this.setState({ deleteModalShow: false });

    fetch(BaseUrl + "deleteStepOfOrderProcess", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        // console.log(result);
        if (result.status === 200) {
          this.readOrderProcess();
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  editStatusText(item) {
    this.setState({
      currentDeleteItemId: item.BUTId,
      desValue: item.statusText,
      editDesModalShow: true,
      currentRoutinItem: item,
    });
  }

  onConfirmDes() {
    if (!this.state.desValue) {
      this.setState({ desErrorText: "توضیح گام این را مشخص کنید" });
      return;
    } else {
      this.setState({ desErrorText: "" });
    }

    let data = {
      businessCode: this.props.match.params.id,
      BUTId: this.state.currentDeleteItemId,
      statusText: this.state.desValue,
    };
    data = Object.assign(data, Authorization());
    console.log(data);
    this.setState({ writingProgress: true });

    fetch(BaseUrl + "changeStatusText", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        // console.log(result);
        if (result.status === 200) {
          this.readOrderProcess();
          this.setState({ editDesModalShow: false });
          toast.success("توضیح گام مورد نظر با موفقیت تغییر کرد", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
        this.setState({ writingProgress: false });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    if (!this.state.dataLoading)
      if (this.state.pageStatus === "normal")
        return (
          <div className="Login">
            <div className="header">
              <div
                onClick={this.onBack.bind(this)}
                className="linkStyle backButton"
              >
                <img
                  src={Back}
                  alt=""
                  className="backButtonIcon"
                  style={{ transform: "rotate(180deg)" }}
                />
                بازگشت
              </div>
              <Tooltip title="خروج">
                <div
                  onClick={this.onLogout.bind(this)}
                  className="linkStyle backButton"
                  // data-tip="خروج"
                  // data-place="bottom"
                >
                  <img src={Logout} alt="" className="backButtonIcon" />
                </div>
              </Tooltip>
            </div>
            <div className="LoginContent">
              <div className="RestaurantsListTitle">روال سفارش</div>
              <div
                style={{ width: "95vw", maxWidth: "1200px", marginTop: "20px" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "fit-content",
                  }}
                >
                  <CustomButton
                    title="گام جدید"
                    imgHeight={20}
                    imgWidth={25}
                    flexDirection="row-reverse"
                    minHeight="35px"
                    img={Plus}
                    onClick={this.ShowCreateNewDialog.bind(this)}
                  />
                </div>
                <SortableList
                  onSortEnd={this.onDragEnd.bind(this)}
                  className="grid"
                  style={{ marginTop: "10px" }}
                  draggedItemClassName="fiObjectItemDrag"
                >
                  {this.state.stepList.map((item, i) => {
                    return (
                      <SortableItem key={i}>
                        <div>
                          <RoutinItem
                            item={item}
                            placeName={item.placeName}
                            statusText={item.statusText}
                            editStatusText={this.editStatusText.bind(this)}
                            editItem={this.editRoutinItem.bind(this)}
                            deleteItem={this.deleteRoutinItem.bind(this)}
                          />
                        </div>
                      </SortableItem>
                    );
                  })}
                </SortableList>
                {/* </div> */}
              </div>
            </div>

            <Modal
              show={this.state.editDesModalShow}
              size="md"
              animation={true}
              onHide={() => {
                this.setState({ editDesModalShow: false });
              }}
              centered
            >
              <div className="settingContainer" style={{ padding: "10px" }}>
                {this.state.currentRoutinItem && (
                  <div className="ModalTitleSM">
                    ویرایش توضیح {this.state.currentRoutinItem.placeName}
                  </div>
                )}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    overflow: "auto",
                    marginTop: "20px",
                    padding: "5px",
                    width: "100%",
                  }}
                >
                  <div className="settingItemContainer">
                    <div
                      className="settingLabel"
                      style={{ textAlign: "right", whiteSpace: "noWrap" }}
                    >
                      توضیح
                    </div>
                    <Form.Control
                      maxLength="50"
                      className={
                        this.state.desErrorText !== ""
                          ? "inputStyleForm inputError textAlignCenter"
                          : "inputStyleForm textAlignCenter"
                      }
                      style={{ direction: "ltr", maxWidth: "200px" }}
                      placeholder="توضیح"
                      type="text"
                      name="desValue"
                      // disabled={this.state.modalType !== 0}
                      onChange={this.textHandleChange.bind(this)}
                      value={this.state.desValue}
                    />
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    maxWidth: "500px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: "20px",
                    alignItems: "center",
                  }}
                >
                  <div style={{ flex: "1" }}>
                    <CustomButton
                      title="ویرایش"
                      loading={this.state.writingProgress}
                      imgHeight={20}
                      imgWidth={25}
                      minHeight="35px"
                      img={Tick}
                      onClick={this.onConfirmDes.bind(this)}
                    />
                  </div>
                  <div style={{ minWidth: "10px" }} />
                  <div style={{ flex: "0.8" }}>
                    <CustomButton
                      title="انصراف"
                      imgHeight={19}
                      backColor="var(--black1)"
                      imgWidth={25}
                      minHeight="35px"
                      img={Cancel}
                      onClick={() => {
                        this.setState({ editDesModalShow: false });
                      }}
                    />
                  </div>
                </div>
              </div>
            </Modal>

            <Modal
              show={this.state.ModalShow}
              size="md"
              animation={true}
              onHide={this.hideModal.bind(this)}
              centered
            >
              <div className="settingContainer" style={{ padding: "10px" }}>
                {!this.state.currentRoutinItem ? (
                  <div className="ModalTitleSM">گام جدید</div>
                ) : (
                  <div className="ModalTitleSM">
                    ویرایش {this.state.currentRoutinItem.titleFa}
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    overflow: "auto",
                    marginTop: "20px",
                    padding: "5px",
                    width: "100%",
                  }}
                >
                  <div className="settingItemContainer">
                    <div
                      className="settingLabel"
                      style={{ textAlign: "right", whiteSpace: "noWrap" }}
                    >
                      عنوان
                    </div>
                    <Form.Control
                      maxLength="50"
                      className={
                        this.state.titleErrorText !== ""
                          ? "inputStyleForm inputError textAlignCenter"
                          : "inputStyleForm textAlignCenter"
                      }
                      style={{ direction: "ltr", maxWidth: "200px" }}
                      placeholder="عنوان"
                      type="text"
                      name="titleValue"
                      // disabled={this.state.modalType !== 0}
                      onChange={this.textHandleChange.bind(this)}
                      value={this.state.titleValue}
                    />
                  </div>

                  {!this.state.currentRoutinItem && (
                    <div
                      className="settingItemContainer"
                      style={{ flexDirection: "column" }}
                    >
                      <div style={{ width: "100%" }}>
                        <CustomButton
                          title="انتخاب محل"
                          imgHeight={20}
                          imgWidth={25}
                          minHeight="35px"
                          onClick={this.onShowPlaces.bind(this)}
                        />
                      </div>

                      {this.state.selectedPlaceList.length > 0 && (
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            marginTop: "10px",
                          }}
                        >
                          {this.state.selectedPlaceList.map((item, i) => {
                            return this.state.placeList.map((item1, i1) => {
                              if (item === item1.id) {
                                return (
                                  <div
                                    style={{
                                      padding: "5px",
                                      backgroundColor: "var(--gray1)",
                                      border: "1px solid var(--brown1)",
                                      borderRadius: "4px",
                                      margin: "5px",
                                      textAlign: "center",
                                      position: "relative",
                                    }}
                                    key={i}
                                  >
                                    {item1.titleFa}
                                    <div
                                      key={i}
                                      style={{
                                        width: "15px",
                                        height: "15px",
                                        backgroundColor: "var(--brown1)",
                                        position: "absolute",
                                        right: "-8px",
                                        top: "-7px",
                                        borderRadius: "50%",
                                        textAlign: "center",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        color: "white",
                                        fontSize: "10px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        let list = JSON.parse(
                                          JSON.stringify(
                                            this.state.selectedPlaceList
                                          )
                                        );
                                        let temp = list.filter(
                                          (el) => el !== item
                                        );

                                        this.setState({
                                          selectedPlaceList: temp,
                                          selectedUserList: [],
                                        });
                                      }}
                                    >
                                      &#10006;
                                    </div>
                                  </div>
                                );
                              } else return null;
                            });
                          })}
                        </div>
                      )}
                    </div>
                  )}

                  <div
                    className="settingItemContainer"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <div
                      className="settingItemContainer"
                      style={{
                        padding: "0px",
                        margin: "0px",
                        flexDirection: "column",
                      }}
                    >
                      <div style={{ width: "100%" }}>
                        <CustomButton
                          title="انتخاب محصول"
                          imgHeight={20}
                          imgWidth={25}
                          minHeight="35px"
                          onClick={this.onShowCats.bind(this)}
                        />
                      </div>

                      {this.state.selectedCatList.length > 0 && (
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            marginTop: "10px",
                          }}
                        >
                          <div
                            style={{
                              padding: "5px",
                              backgroundColor: "var(--gray1)",
                              border: "1px solid var(--brown1)",
                              borderRadius: "4px",
                              margin: "5px",
                              textAlign: "center",
                              position: "relative",
                            }}
                          >
                            {this.state.selectedCatList.length + " محصول"}
                            <div
                              style={{
                                width: "15px",
                                height: "15px",
                                backgroundColor: "var(--brown1)",
                                position: "absolute",
                                right: "-8px",
                                top: "-7px",
                                borderRadius: "50%",
                                textAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: "white",
                                fontSize: "10px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                this.setState({
                                  selectedCatList: [],
                                });
                              }}
                            >
                              &#10006;
                            </div>
                          </div>

                          {/* {this.state.selectedCatList.map((item, i) => {
                            return this.state.catList.map((item1, i1) => {
                              if (item === item1.id) {
                                return (
                                  
                                );
                              } else return null;
                            });
                          })} */}
                        </div>
                      )}
                    </div>
                  </div>

                  <div
                    className="settingItemContainer"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    {/* <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div
                        className="settingLabel"
                        style={{ textAlign: "right" }}
                      >
                        تخصیص همه ایستگاه‌های انتخاب نشده
                      </div>
                      <BootstrapSwitchButton
                        checked={this.state.otherStation}
                        onChange={(checked) => {
                          this.setState({ otherStation: checked });
                        }}
                        onlabel="بله"
                        offlabel="خیر"
                        onstyle="primary"
                        offstyle="warning"
                        width={75}
                      />
                    </div>
                    {!this.state.otherStation && ( */}
                    <div
                      className="settingItemContainer"
                      style={{
                        padding: "0px",
                        margin: "0px",
                        // marginTop: "10px",
                        flexDirection: "column",
                      }}
                    >
                      <div style={{ width: "100%" }}>
                        <CustomButton
                          title="انتخاب ایستگاه"
                          imgHeight={20}
                          imgWidth={25}
                          minHeight="35px"
                          onClick={this.onShowStations.bind(this)}
                        />
                      </div>

                      {this.state.selectedStationList.length > 0 && (
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            marginTop: "10px",
                          }}
                        >
                          {this.state.selectedStationList.map((item, i) => {
                            return this.state.stationList.map((item1, i1) => {
                              if (item === item1.id) {
                                return (
                                  <div
                                    style={{
                                      padding: "5px",
                                      backgroundColor: "var(--gray1)",
                                      border: "1px solid var(--brown1)",
                                      borderRadius: "4px",
                                      margin: "5px",
                                      textAlign: "center",
                                      position: "relative",
                                    }}
                                    key={i}
                                  >
                                    {item1.name}
                                    <div
                                      key={i}
                                      style={{
                                        width: "15px",
                                        height: "15px",
                                        backgroundColor: "var(--brown1)",
                                        position: "absolute",
                                        right: "-8px",
                                        top: "-7px",
                                        borderRadius: "50%",
                                        textAlign: "center",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        color: "white",
                                        fontSize: "10px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        let list = JSON.parse(
                                          JSON.stringify(
                                            this.state.selectedStationList
                                          )
                                        );
                                        let temp = list.filter(
                                          (el) => el !== item
                                        );

                                        this.setState({
                                          selectedStationList: temp,
                                        });
                                      }}
                                    >
                                      &#10006;
                                    </div>
                                  </div>
                                );
                              } else return null;
                            });
                          })}
                        </div>
                      )}
                    </div>
                    {/* )} */}
                  </div>

                  <div
                    className="settingItemContainer"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <div
                      className="settingItemContainer"
                      style={{
                        padding: "0px",
                        margin: "0px",
                        flexDirection: "column",
                      }}
                    >
                      <div style={{ width: "100%" }}>
                        <CustomButton
                          title="انتخاب کاربر"
                          imgHeight={20}
                          imgWidth={25}
                          minHeight="35px"
                          disabled={
                            this.state.selectedPlaceList.length > 0
                              ? false
                              : true
                          }
                          onClick={this.onShowUsers.bind(this)}
                        />
                      </div>

                      {this.state.selectedPlaceList.length === 0 && (
                        <div
                          style={{
                            width: "100%",
                            fontSize: "11px",
                            textAlign: "right",
                            color: "var(--red1)",
                            marginTop: "5px",
                          }}
                        >
                          برای انتخاب کاربر ابتدا باید محل گام مشخص شود
                        </div>
                      )}
                      {this.state.selectedUserList.length > 0 && (
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            marginTop: "10px",
                          }}
                        >
                          {this.state.selectedUserList.map((item, i) => {
                            return this.state.userList.map((item1, i1) => {
                              if (item === item1.id) {
                                return (
                                  <div
                                    style={{
                                      padding: "5px",
                                      backgroundColor: "var(--gray1)",
                                      border: "1px solid var(--brown1)",
                                      borderRadius: "4px",
                                      margin: "5px",
                                      textAlign: "center",
                                      position: "relative",
                                    }}
                                    key={i}
                                  >
                                    {item1.userName}
                                    <div
                                      key={i}
                                      style={{
                                        width: "15px",
                                        height: "15px",
                                        backgroundColor: "var(--brown1)",
                                        position: "absolute",
                                        right: "-8px",
                                        top: "-7px",
                                        borderRadius: "50%",
                                        textAlign: "center",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        color: "white",
                                        fontSize: "10px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        let list = JSON.parse(
                                          JSON.stringify(
                                            this.state.selectedUserList
                                          )
                                        );
                                        let temp = list.filter(
                                          (el) => el !== item
                                        );

                                        this.setState({
                                          selectedUserList: temp,
                                        });
                                      }}
                                    >
                                      &#10006;
                                    </div>
                                  </div>
                                );
                              } else return null;
                            });
                          })}
                        </div>
                      )}
                    </div>
                  </div>

                  <div
                    className="settingItemContainer"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <div
                      className="settingItemContainer"
                      style={{
                        padding: "0px",
                        margin: "0px",
                        flexDirection: "column",
                      }}
                    >
                      <div style={{ width: "100%" }}>
                        <CustomButton
                          title="انتخاب چاپگر"
                          imgHeight={20}
                          imgWidth={25}
                          minHeight="35px"
                          onClick={this.onShowPrinter.bind(this)}
                        />
                      </div>

                      {this.state.selectedPrinterList.length > 0 && (
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            marginTop: "10px",
                          }}
                        >
                          {this.state.selectedPrinterList.map((item, i) => {
                            return this.state.printerList.map((item1, i1) => {
                              if (item === item1.id) {
                                return (
                                  <div
                                    style={{
                                      padding: "5px",
                                      backgroundColor: "var(--gray1)",
                                      border: "1px solid var(--brown1)",
                                      borderRadius: "4px",
                                      margin: "5px",
                                      textAlign: "center",
                                      position: "relative",
                                    }}
                                    key={i}
                                  >
                                    {item1.printerName}
                                    <div
                                      key={i}
                                      style={{
                                        width: "15px",
                                        height: "15px",
                                        backgroundColor: "var(--brown1)",
                                        position: "absolute",
                                        right: "-8px",
                                        top: "-7px",
                                        borderRadius: "50%",
                                        textAlign: "center",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        color: "white",
                                        fontSize: "10px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        let list = JSON.parse(
                                          JSON.stringify(
                                            this.state.selectedPrinterList
                                          )
                                        );
                                        let temp = list.filter(
                                          (el) => el !== item
                                        );

                                        this.setState({
                                          selectedPrinterList: temp,
                                        });
                                      }}
                                    >
                                      &#10006;
                                    </div>
                                  </div>
                                );
                              } else return null;
                            });
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    width: "100%",
                    maxWidth: "500px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: "20px",
                    alignItems: "center",
                  }}
                >
                  <div style={{ flex: "1" }}>
                    <CustomButton
                      title="ذخیره"
                      loading={this.state.writingProgress}
                      imgHeight={20}
                      imgWidth={25}
                      minHeight="35px"
                      img={Tick}
                      onClick={this.onConfirmStep.bind(this)}
                    />
                  </div>
                  <div style={{ minWidth: "10px" }} />
                  <div style={{ flex: "0.8" }}>
                    <CustomButton
                      title="انصراف"
                      imgHeight={19}
                      backColor="var(--black1)"
                      imgWidth={25}
                      minHeight="35px"
                      img={Cancel}
                      onClick={this.hideModal.bind(this)}
                    />
                  </div>
                </div>
              </div>
            </Modal>

            <Modal
              show={this.state.ModalShow1}
              animation={true}
              size="md"
              backdrop="static"
              backdropClassName="backdropClassName"
              onHide={() => {
                this.setState({ ModalShow1: false });
              }}
              centered
            >
              {this.state.listType === "printer" && (
                <ListViewer
                  listType={this.state.listType}
                  currentSelected={this.state.selectedPrinterList}
                  list={this.state.printerList}
                  loading={this.state.printerListLoading}
                  onConfirmPrinter={this.onConfirmPrinter.bind(this)}
                  hideModal={() => {
                    this.setState({ ModalShow1: false });
                  }}
                />
              )}

              {this.state.listType === "place" && (
                <ListViewer
                  listType={this.state.listType}
                  currentSelected={this.state.selectedPlaceList}
                  list={this.state.placeList}
                  loading={this.state.placeListLoading}
                  onConfirmPlace={this.onConfirmPlace.bind(this)}
                  hideModal={() => {
                    this.setState({ ModalShow1: false });
                  }}
                />
              )}

              {this.state.listType === "product" && (
                <ListViewer
                  listType={this.state.listType}
                  currentSelected={this.state.selectedCatList}
                  list={this.state.catList}
                  loading={this.state.placeListLoading}
                  onConfirmProduct={this.onConfirmProduct.bind(this)}
                  hideModal={() => {
                    this.setState({ ModalShow1: false });
                  }}
                />
              )}

              {this.state.listType === "station" && (
                <ListViewer
                  listType={this.state.listType}
                  currentSelected={this.state.selectedStationList}
                  list={this.state.stationList}
                  loading={this.state.placeListLoading}
                  onConfirmStation={this.onConfirmStation.bind(this)}
                  hideModal={() => {
                    this.setState({ ModalShow1: false });
                  }}
                />
              )}

              {this.state.listType === "user" && (
                <ListViewer
                  listType={this.state.listType}
                  currentSelected={this.state.selectedUserList}
                  list={this.state.userList}
                  loading={this.state.placeListLoading}
                  onConfirmUser={this.onConfirmUser.bind(this)}
                  hideModal={() => {
                    this.setState({ ModalShow1: false });
                  }}
                />
              )}
            </Modal>

            <Modal
              show={this.state.warningModalShow}
              animation={true}
              size="md"
              backdrop="static"
              backdropClassName="backdropClassName"
              onHide={() => {
                this.setState({ warningModalShow: false });
              }}
              centered
            >
              <div
                className="dialogBox"
                style={{
                  maxHeight: "unset",
                  alignSelf: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "right",
                    overflowY: "auto",
                    maxHeight: "400px",
                    width: "100%",
                  }}
                >
                  <div style={{ fontSize: "18px" }}>
                    لطفاً به هشدارهای زیر توجه کنید:
                  </div>

                  <div style={{ minHeight: "20px" }} />
                  <div
                    style={{
                      fontSize: "14px",
                    }}
                  >
                    {this.state.warningList.map((item, i) => {
                      return (
                        <div key={i}>
                          {i + 1}. {item}
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: "20px",
                    alignItems: "center",
                  }}
                >
                  <div style={{ flex: "1" }}>
                    <CustomButton
                      title="انصراف"
                      imgHeight={19}
                      backColor="var(--black1)"
                      imgWidth={25}
                      minHeight="35px"
                      img={Cancel}
                      onClick={() => this.setState({ warningModalShow: false })}
                    />
                  </div>
                  <div style={{ minWidth: "5px" }} />
                  <div style={{ flex: "1" }}>
                    <CustomButton
                      title="متوجه شدم، تاببد"
                      // loading={this.state.deleteLoading}
                      imgHeight={20}
                      imgWidth={25}
                      minHeight="35px"
                      img={Tick}
                      onClick={() => {
                        this.setState({ warningModalShow: false });
                        this.createEditProcess();
                      }}
                    />
                  </div>
                </div>
              </div>
            </Modal>

            <Modal
              show={this.state.deleteModalShow}
              animation={false}
              onHide={() => this.setState({ deleteModalShow: false })}
              centered
            >
              <div className="dialogBox">
                اطمینان از حذف "{this.state.currentDeleteItemName}"؟
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: "20px",
                    alignItems: "center",
                  }}
                >
                  <div style={{ flex: "1" }}>
                    <CustomButton
                      title="خیر"
                      imgHeight={19}
                      backColor="var(--black1)"
                      imgWidth={25}
                      minHeight="35px"
                      img={Cancel}
                      onClick={() => this.setState({ deleteModalShow: false })}
                    />
                  </div>
                  <div style={{ minWidth: "5px" }} />
                  <div style={{ flex: "1" }}>
                    <CustomButton
                      title="بله"
                      // loading={this.state.deleteLoading}
                      imgHeight={20}
                      imgWidth={25}
                      minHeight="35px"
                      img={Tick}
                      onClick={this.itemDeleteConfirm.bind(this)}
                    />
                  </div>
                </div>
              </div>
            </Modal>
            {/* <ReactTooltip effect="solid" /> */}
          </div>
        );
      else
        return (
          <form
            style={{ display: "none" }}
            action="https://sep.shaparak.ir/OnlinePG/OnlinePG"
            method="post"
          >
            <input type="hidden" name="Token" value={this.state.paymentToken} />
            <input type="text" name="GetMethod" value="false" readOnly />
            <input
              ref={this.paymentForm}
              type="submit"
              name="submit"
              value="submit"
            />
          </form>
        );
    else return <Loading />;
  }
}
